import React from "react";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import ActivitatWeek from "./ActivitatWeek";
import { styled } from "@mui/material";

export const DiaBox = styled(Box)(({ theme }) => ({
	padding: 20,
	"&>h3": {
		color: "white",
	},
}));

export const PackGrid = styled(Grid)(({ theme }) => ({
	border: "5px solid",
	margin: 0,
	marginTop: 10,
}));

export const PackTitol = styled(Grid)(({ theme }) => ({
	backgroundColor: "white",
	textAlign: "center",
}));

const ActivitatsWeek = (props) => {
	const { activitats, packs, color, values, setFieldValue, setContinuar } =
		props;
	const matches = useMediaQuery("(min-width:960px)");
	const hores = [...new Set(activitats.map((a) => a.hora_i))];

	const selPack = (activitats) => {
		if (String(activitats[0].publicada) !== "0") {
			let aux = [];

			activitats.map((item) => (aux = [...aux, item.id]));
			let newActivitats = values.activitat;

			aux.map((id) => {
				if (newActivitats?.includes(id)) {
					let newValues = newActivitats.filter(function (element) {
						return element !== id;
					});
					newActivitats = newValues;
				} else {
					newActivitats = [...newActivitats, id];
				}
			});

			setFieldValue("activitat", newActivitats);

			if (newActivitats.length > 0) {
				setContinuar(true);
			} else {
				setContinuar(false);
			}
		}
	};

	return (
		<>
			<Box sx={{ display: { xl: "block", xs: "none" } }}>
				<Grid container spacing={1}>
					<Grid item size={2.4}>
						<DiaBox style={{ backgroundColor: color }}>
							<Typography variant="h3">Dilluns</Typography>
						</DiaBox>
					</Grid>
					<Grid item size={2.4}>
						<DiaBox style={{ backgroundColor: color }}>
							<Typography variant="h3">Dimarts</Typography>
						</DiaBox>
					</Grid>
					<Grid item size={2.4}>
						<DiaBox style={{ backgroundColor: color }}>
							<Typography variant="h3">Dimecres</Typography>
						</DiaBox>
					</Grid>
					<Grid item size={2.4}>
						<DiaBox style={{ backgroundColor: color }}>
							<Typography variant="h3">Dijous</Typography>
						</DiaBox>
					</Grid>
					<Grid item size={2.4}>
						<DiaBox style={{ backgroundColor: color }}>
							<Typography variant="h3">Divendres</Typography>
						</DiaBox>
					</Grid>
				</Grid>
			</Box>

			{activitats?.map((item) => {
				return (
					String(item.setmanal) === "1" && (
						<ActivitatWeek
							color={color}
							activitat={item}
							setFieldValue={setFieldValue}
							values={values}
							setContinuar={setContinuar}
							key={item.id}
						/>
					)
				);
			})}
			{packs?.map((item) => {
				return (
					item.activitats.length !== 0 && (
						<PackGrid
							container
							spacing={1}
							style={{ borderColor: color }}
							onClick={() => selPack(item.activitats)}
						>
							<PackTitol item size={12}>
								<Typography
									variant="h4"
									style={{
										color: color,
										padding: 5,
										fontSize: 25,
									}}
								>
									{item.nom} - {item.preu} €
								</Typography>
							</PackTitol>
							<Grid item size={{ xs: 12, md: 2.4 }}>
								{item.activitats?.map((item) => {
									return (
										String(item.dia) === "1" && (
											<ActivitatWeek
												color={color}
												activitat={item}
												setFieldValue={setFieldValue}
												values={values}
												setContinuar={setContinuar}
												key={item.id}
											/>
										)
									);
								})}
							</Grid>
							<Grid item size={{ xs: 12, md: 2.4 }}>
								{item.activitats?.map((item) => {
									return (
										String(item.dia) === "2" && (
											<ActivitatWeek
												color={color}
												activitat={item}
												setFieldValue={setFieldValue}
												setContinuar={setContinuar}
												values={values}
												key={item.id}
											/>
										)
									);
								})}
							</Grid>
							<Grid item size={{ xs: 12, md: 2.4 }}>
								{item.activitats?.map((item) => {
									return (
										String(item.dia) === "3" && (
											<ActivitatWeek
												color={color}
												activitat={item}
												setFieldValue={setFieldValue}
												setContinuar={setContinuar}
												values={values}
												key={item.id}
											/>
										)
									);
								})}
							</Grid>
							<Grid item size={{ xs: 12, md: 2.4 }}>
								{item.activitats?.map((item) => {
									return (
										String(item.dia) === "4" && (
											<ActivitatWeek
												color={color}
												activitat={item}
												setFieldValue={setFieldValue}
												setContinuar={setContinuar}
												values={values}
												key={item.id}
											/>
										)
									);
								})}
							</Grid>
							<Grid item size={{ xs: 12, md: 2.4 }}>
								{item.activitats?.map((item) => {
									return (
										String(item.dia) === "5" && (
											<ActivitatWeek
												color={color}
												activitat={item}
												setFieldValue={setFieldValue}
												setContinuar={setContinuar}
												values={values}
												key={item.id}
											/>
										)
									);
								})}
							</Grid>
						</PackGrid>
					)
				);
			})}
			{matches && (
				<table>
					{hores?.map((h) => (
						<tr>
							<td
								width={matches ? "20%" : "100%"}
								style={{ verticalAlign: "top" }}
							>
								{activitats?.map((item) => {
									return (
										String(item.dia) === "1" &&
										item.hora_i === h &&
										item.pack_id === null && (
											<ActivitatWeek
												color={color}
												activitat={item}
												setFieldValue={setFieldValue}
												values={values}
												setContinuar={setContinuar}
												key={item.id}
											/>
										)
									);
								})}
							</td>
							<td
								width={matches ? "20%" : "100%"}
								style={{ verticalAlign: "top" }}
							>
								{activitats?.map((item) => {
									return (
										String(item.dia) === "2" &&
										item.hora_i === h &&
										item.pack_id === null && (
											<ActivitatWeek
												color={color}
												activitat={item}
												setFieldValue={setFieldValue}
												values={values}
												setContinuar={setContinuar}
												key={item.id}
											/>
										)
									);
								})}
							</td>
							<td
								width={matches ? "20%" : "100%"}
								style={{ verticalAlign: "top" }}
							>
								{activitats?.map((item) => {
									return (
										String(item.dia) === "3" &&
										item.hora_i === h &&
										item.pack_id === null && (
											<ActivitatWeek
												color={color}
												activitat={item}
												setFieldValue={setFieldValue}
												values={values}
												setContinuar={setContinuar}
												key={item.id}
											/>
										)
									);
								})}
							</td>
							<td
								width={matches ? "20%" : "100%"}
								style={{ verticalAlign: "top" }}
							>
								{activitats?.map((item) => {
									return (
										String(item.dia) === "4" &&
										item.hora_i === h &&
										item.pack_id === null && (
											<ActivitatWeek
												color={color}
												activitat={item}
												setFieldValue={setFieldValue}
												values={values}
												setContinuar={setContinuar}
												key={item.id}
											/>
										)
									);
								})}
							</td>
							<td
								width={matches ? "20%" : "100%"}
								style={{ verticalAlign: "top" }}
							>
								{activitats?.map((item) => {
									return (
										String(item.dia) === "5" &&
										item.hora_i === h &&
										item.pack_id === null && (
											<ActivitatWeek
												color={color}
												activitat={item}
												setFieldValue={setFieldValue}
												values={values}
												setContinuar={setContinuar}
												key={item.id}
											/>
										)
									);
								})}
							</td>
						</tr>
					))}
				</table>
			)}
			{!matches && (
				<Grid container spacing={1}>
					<Grid item size={12} md>
						{activitats?.map((item) => {
							return (
								String(item.dia) === "1" &&
								item.pack_id === null && (
									<ActivitatWeek
										color={color}
										activitat={item}
										setFieldValue={setFieldValue}
										values={values}
										setContinuar={setContinuar}
										key={item.id}
									/>
								)
							);
						})}
					</Grid>
					<Grid item size={12} md>
						{activitats?.map((item) => {
							return (
								String(item.dia) === "2" &&
								item.pack_id === null && (
									<ActivitatWeek
										color={color}
										activitat={item}
										setFieldValue={setFieldValue}
										setContinuar={setContinuar}
										values={values}
										key={item.id}
									/>
								)
							);
						})}
					</Grid>
					<Grid item size={12} md>
						{activitats?.map((item) => {
							return (
								String(item.dia) === "3" &&
								item.pack_id === null && (
									<ActivitatWeek
										color={color}
										activitat={item}
										setFieldValue={setFieldValue}
										setContinuar={setContinuar}
										values={values}
										key={item.id}
									/>
								)
							);
						})}
					</Grid>
					<Grid item size={12} md>
						{activitats?.map((item) => {
							return (
								String(item.dia) === "4" &&
								item.pack_id === null && (
									<ActivitatWeek
										color={color}
										activitat={item}
										setFieldValue={setFieldValue}
										setContinuar={setContinuar}
										values={values}
										key={item.id}
									/>
								)
							);
						})}
					</Grid>
					<Grid item size={12} md>
						{activitats?.map((item) => {
							return (
								String(item.dia) === "5" &&
								item.pack_id === null && (
									<ActivitatWeek
										color={color}
										activitat={item}
										setFieldValue={setFieldValue}
										setContinuar={setContinuar}
										values={values}
										key={item.id}
									/>
								)
							);
						})}
					</Grid>
				</Grid>
			)}
		</>
	);
};

export default ActivitatsWeek;
